import './node-globals-shim.js'; // must be first — see comment in that file
import './public-path.js';
// Eager-preload of MOL plugins / i18n / configs. By default this resolves to
// `./molEagerPreload.js` (a no-op). The MOL production build (vite.mol.config.js)
// re-aliases it to `./molEagerPreload.bundle.js`, which statically imports the
// modules so they ship inside main.js. See those files for details.
import './molEagerPreload.js';
import * as engine from '../src/main.ts';

window.LocusLabsMaps = engine;
